import defaultTheme from 'tailwindcss/defaultTheme';
const boxShadow = {
    boxShadow: {
        ...defaultTheme.boxShadow,
        tooltip: '2px -2px 30px -10px rgba(0,0,0,0.25)',
        modal: '2px -2px 20px -12px rgba(0,0,0,0.25)',
        focus: '0 0 0 1pt #184D7B'
    }
};
export default boxShadow;
